import React, { useCallback, useState } from 'react';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';

import Popup from '../Popup';
import Icon from '../../Icon';
import Button from '../../Button';
import TimePicker from '../TimePicker';
import TextInput from '../../TextInput';
import ValidationError from '../ValidationError';
import { COLORS } from '../../../constants/styles';

import styles from './index.styl';

export function getTime() {
  return moment()
    .add(5, 'minute')
    .format('hh:mm a');
}

function TimePickerInput({
  name,
  label,
  time,
  value,
  onChange,
  className,
  placeholder,
  validateTime,
  intl: { formatMessage },
  withCurrentTime,
  disabled,
  saveButtonTitle = formatMessage({ id: 'common.ok' }),
  cancelButtonTitle = formatMessage({ id: 'common.cancel' }),
}) {
  const [isPopupVisible, toggleVisibility] = useState(false);
  const [pickerTime, setTime] = useState(withCurrentTime ? getTime() : time);
  const [error, showError] = useState(null);

  const togglePopup = useCallback(() => {
    toggleVisibility(!isPopupVisible);
    showError(null);
  }, [isPopupVisible, toggleVisibility]);

  const handleSave = () => {
    const errorMessage = validateTime && validateTime(pickerTime);

    if (!errorMessage) {
      onChange(pickerTime);
      toggleVisibility(false);
    } else {
      showError(errorMessage);
    }
  };

  return (
    <div styleName="root" className={className}>
      <TextInput
        rounded
        name={name}
        type="text"
        value={value}
        onFocus={togglePopup}
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        readOnly
      >
        <Icon
          styleName="icon"
          name="time"
          style={{ fill: COLORS.bluePrimary }}
        />
      </TextInput>
      <Popup
        opened={isPopupVisible}
        white
        width="rubber"
        enabled
        withHeading={false}
        contentNoPadding
        mobileFullScreen={false}
      >
        <TimePicker time={pickerTime} onChange={val => setTime(val)} />
        <If condition={error}>
          <ValidationError content={error} className="f-14 tc" />
        </If>
        <div className="pt3 pb1 flex justify-end">
          <Button color="transparent" onClick={togglePopup}>
            {cancelButtonTitle}
          </Button>
          <Button color="transparent" onClick={handleSave}>
            {saveButtonTitle}
          </Button>
        </div>
      </Popup>
    </div>
  );
}

TimePickerInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  time: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  cancelButtonTitle: PropTypes.string,
  saveButtonTitle: PropTypes.string,
  validateTime: PropTypes.func,
  intl: PropTypes.object,
  value: PropTypes.string,
  withCurrentTime: PropTypes.bool,
  disabled: PropTypes.bool,
};

TimePickerInput.defaultProps = {
  time: '12:00',
  withCurrentTime: false,
};

export default injectIntl(
  CSSModules(TimePickerInput, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/common/TimePickerInput/index.jsx